import { Link } from "react-router-dom";
import type { SpecialItem } from "@/mocks/specials";

interface SpecialShowcaseProps {
  items: SpecialItem[];
}

export default function SpecialShowcase({ items }: SpecialShowcaseProps) {
  return (
    <section id="specials" aria-label="推荐专题合集" className="scroll-mt-20">
      <div className="mb-5 flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-200 text-secondary-900">
          <i className="ri-bookmark-3-line text-xl"></i>
        </span>
        <div>
          <h2 className="font-heading text-lg font-black text-foreground-950 md:text-xl">
            推荐专题合集
          </h2>
          <p className="mt-1 text-xs text-foreground-500 md:text-sm">
            按主题深度浏览，发现值得一看的内容
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {items.map((item) => (
          <Link
            key={item.id}
            to={`/special/${item.id}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-200 hover:border-secondary-400"
          >
            <div className="relative h-40 w-full overflow-hidden bg-background-100">
              <img
                src={item.cover}
                alt={`${item.title}专题封面`}
                title={`${item.title}精选专题`}
                className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
              <h3 className="absolute bottom-3 left-4 right-4 font-heading text-lg font-black text-background-50">
                {item.title}
              </h3>
            </div>
            <div className="flex flex-1 flex-col p-4">
              <p className="text-sm font-medium text-secondary-800">{item.subtitle}</p>
              <p className="mt-2 line-clamp-3 text-xs leading-relaxed text-foreground-600">
                {item.intro}
              </p>
              <span className="mt-4 flex items-center gap-1 text-xs font-medium text-primary-700 group-hover:text-primary-800">
                进入专题
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}